<div class="flex min-h-0 flex-1 overflow-hidden" *transloco="let t">
  <div class="min-h-0 min-w-0 flex-1 overflow-hidden" [class.max-lg:hidden]="open()">
    <ng-content select="[splitMain]" />
  </div>

  <div
    class="flex min-h-0 shrink-0 flex-col overflow-hidden border-l duration-150"
    [class.w-auto]="!open()"
    [class.w-full]="open()"
    [class.lg:w-160]="open()"
  >
    <div
      class="flex shrink-0 items-center gap-2 px-5 py-3"
      [class.justify-between]="open()"
      [class.justify-center]="!open()"
      [class.border-b]="open()"
    >
      @if (open()) {
        <IBadge color="gray" size="xs" icon="eye" [label]="t(badgeLabelKey())" />
      }
      <button
        iButton
        type="button"
        variant="secondary"
        size="icon-sm"
        [attr.aria-label]="open() ? t('form-preview-split.hide_preview') : t('form-preview-split.show_preview')"
        [iTooltip]="open() ? t('form-preview-split.hide_preview') : t('form-preview-split.show_preview')"
        iTooltipPlacement="bottom-end"
        (click)="toggle()"
      >
        <IIcon [name]="open() ? 'sidebarRight' : 'sidebarLeft'" />
      </button>
    </div>

    <div class="min-h-0 flex-1 overflow-hidden" [class.hidden]="!open()">
      <ng-content select="[splitPreview]" />
    </div>
  </div>
</div>
